import { encrypt, decrypt } from './crypto';


export const safeStore = (key, value) => {
  const encryptedValue = encrypt(value);
  localStorage.setItem(key, encryptedValue);
};

export const safeRetrieve = (key) => {
  const encryptedValue = localStorage.getItem(key);
  return encryptedValue ? decrypt(encryptedValue) : '';
};


export const plainStore = (key, value) => {
  // store the value as a string (if it is a JSON it is converted to a string)
  const isObject = typeof value === 'object' && value !== null;
  const storedValue = isObject ? JSON.stringify(value) : value;
  localStorage.setItem(key, storedValue);
};

export const plainRetrieve = (key) => {
  const value = localStorage.getItem(key);
  
  if (value) {
    try {
      // try to parse JSON
      return JSON.parse(value);
    } catch (error) {
      // if parsing fails, return the value as a string
      return value;
    }
  }
  
  return '';
};

export const storageRemove = (key) => {
  localStorage.removeItem(key);
}
